import { UserInterface, UserPropKey, UserVarKey } from "@swivl-mono/types";
import { memo, useState } from "react";
import { FaEllipsisV } from "react-icons/fa";

import { MoreDetailsDropdown } from "./MoreDetailsDropdown";
import "./NameRow.scss";
import { NameHelper } from "@swivl-mono/helpers";

interface NameRowProps {
  user: UserInterface;
  vars?: { [key in UserVarKey]?: string | undefined };
  handleSetIsEditing: () => void;
}

const BaseNameRow = ({ handleSetIsEditing, vars, user }: NameRowProps) => {
  const [showDetails, setShowDetails] = useState(false);
  // TODO: build out blocked logic
  // const [settingBlocked, setSettingBlocked] = useState(false);
  // const navigate = useNavigate();

  const name = NameHelper.nameForUser(user);

  return (
    <div className="NameRow px-6">
      <div className="flex flex-row">
        {name && <div className="name flex-1">{name}</div>}
        <button className="editButton" onClick={handleSetIsEditing}>
          EDIT
        </button>
        <button className={showDetails ? "moreButton showing" : "moreButton"} onClick={() => setShowDetails(!showDetails)}>
          <FaEllipsisV />
          {showDetails && <MoreDetailsDropdown setShowDetails={setShowDetails} user={user} />}
        </button>
      </div>

      <div className="NameRowBody">
        {user && user?.addressLine1 && <div className="flex flex-row">{user.addressLine1}</div>}
        {user && user?.phoneNumber && <div className="flex flex-row">{user.phoneNumber}</div>}
        {user && user?.email && <div className="flex flex-row">{user.email}</div>}
      </div>
    </div>
  );
};

export const NameRow = memo(BaseNameRow);
